// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"fc01f49c","952":"7250875d"}[chunkId] + ".chunk.js";
};